import { Component, Input } from '@angular/core';
import { IPrintableReportHeading } from '@models/report-print-heading';

@Component({
  selector: 'zbp-printable-report-heading',
  imports: [],
  templateUrl: './printable-report-heading.component.html',
  styleUrl: './printable-report-heading.component.scss'
})
export class PrintableReportHeadingComponent {
  /**
   * Provides a label/value pair of headings to display as columns above a report.
   */
  @Input() headings: IPrintableReportHeading[] = [];
}
